import { defineComponent as _defineComponent } from 'vue'
import { encryptionConfig } from "@/api/php/serverConfig";
import Platform from "@/config/platform";
import { ref, onMounted } from "vue";
import { useRoute, useRouter } from "vue-router";
import Clipboard from "clipboard";
import { Toast } from "vant";
import { cheackQuery, ToBack } from "@/uitls/native";
import { useI18n } from 'vue-i18n'


export default /*#__PURE__*/_defineComponent({
  name: 'InviteFriend',
  setup(__props, { expose }) {
  expose();

const { t } = useI18n()
const router = useRouter();
const route = useRoute();
const friendsBg = require(`@/assets/${process.env.VUE_APP_NAME}/friendsBg_02.jpg`);
const invitebtn = require(`@/assets/${process.env.VUE_APP_NAME}/invitebtn.png`);

onMounted(() => {
    cheackQuery(route);
    getConfig()

});

const downurl = ref("")
const getConfig = async () => {
    const res: any = await encryptionConfig()
    Platform.downUrl = res.data.download_url;
    downurl.value = Platform.downUrl
}

const copyclsaa = (copyclass, data) => {
    // copyclass元素的类名，data要复制的内容
    let clipboard = new Clipboard("." + copyclass, {
        text: () => {
            return data;
        },
    });
    clipboard.on("success", (e) => {
        Toast.success(t('me.fzljcg'));
        clipboard.destroy();
    });
    clipboard.on("error", (e) => {
        console.log("浏览器不支持复制");
        // 释放内存
        clipboard.destroy();
    });
};



const __returned__ = { t, router, route, friendsBg, invitebtn, downurl, getConfig, copyclsaa, ToBack }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})